import { useCallback, useContext } from 'react';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { DataRoomMemberRole } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { isDataRoomOwner } from 'router/subrouters/DataRoom/utils';

export default function useCanEditDataRoomMember() {
  const {
    currentUser: { _id },
  } = useContext(CurrentUserContext);
  const { doesntHaveAccess } = useContext(DataRoomContext);

  const getCanEditMember = useCallback(
    (role: DataRoomMemberRole, userId: string) => {
      const isOwner = isDataRoomOwner(role);
      const isCurrentUser = userId === _id;

      if (doesntHaveAccess || isOwner || isCurrentUser) return false;

      return true;
    },
    [_id, doesntHaveAccess],
  );

  return getCanEditMember;
}
